import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";

export function useDashboardApi() {
  const callApi = useApiCall();

  const getAdoptionDashboardCounts = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_ADOPTION_DASHBOARD_COUNTS, data, onSuccess, onError);
  };

  const exportAdoptionCountsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ADOPTION_COUNTS_PDF, data, onSuccess, onError);
  };
  const exportAdoptionCountsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ADOPTION_COUNTS_XLS, data, onSuccess, onError);
  };
  const exportKpiTotalWRsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_TOTAL_WRS_PDF, data, onSuccess, onError);
  };
  const exportKpiTotalWRsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_TOTAL_WRS_XLS, data, onSuccess, onError);
  };
  const exportKpiAvgTasksToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_TASKS_PDF, data, onSuccess, onError);
  };
  const exportKpiAvgTasksToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_TASKS_XLS, data, onSuccess, onError);
  };
  const exportKpiAvgHoursToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_HOURS_PDF, data, onSuccess, onError);
  };
  const exportKpiAvgHoursToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_HOURS_XLS, data, onSuccess, onError);
  };
  const exportKpiChecklistTasksToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_TASKS_PDF, data, onSuccess, onError);
  };
  const exportKpiChecklistTasksToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_TASKS_XLS, data, onSuccess, onError);
  };
  const exportKpiChecklistCompletionToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_COMPLETION_PDF, data, onSuccess, onError);
  };
  const exportKpiChecklistCompletionToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_COMPLETION_XLS, data, onSuccess, onError);
  };

  const getWorkRequestOrigins = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WORK_REQUEST_ORIGINS, data, onSuccess, onError);
  };

  const getTaskOriginsGallus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_TASK_ORIGINS_GALLUS, data, onSuccess, onError);
  };

  const getGrowerTaskOrigins = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_GROWER_TASK_ORIGINS, data, onSuccess, onError);
  };

  const getWRStatusPieChart = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WR_STATUS_PIE_CHART, data, onSuccess, onError);
  };

  const exportWRStatusPieChartToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_PDF, data, onSuccess, onError);
  };

  const exportWRStatusPieChartToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_XLS, data, onSuccess, onError);
  };

  const getUserActivitySummary = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_USER_ACTIVITY_SUMMARY, data, onSuccess, onError);
  };

  const getStockAdjustmentChart = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_STOCK_ADJUSTMENT_CHART, data, onSuccess, onError);
  };

  const getInventoryMovementChart = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_INVENTORY_MOVEMENT_CHART, data, onSuccess, onError);
  };

  const getManagerDashboardWR = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_WR, data, onSuccess, onError);
  };

  const getManagerDashboardTeam = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_TEAM, data, onSuccess, onError);
  };

  const getManagerDashboardPurchasing = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_PURCHASING, data, onSuccess, onError);
  };

  const getManagerDashboardAssets = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_ASSETS, data, onSuccess, onError);
  };

  const getClosedTasksReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_CLOSED_TASKS_REPORT, data, onSuccess, onError);
  };

  const getAssetsUptimeReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_ASSETS_UPTIME_REPORT, data, onSuccess, onError);
  };

  const getAssetsTimeCostReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_ASSETS_TIME_COST_REPORT, data, onSuccess, onError);
  };

  const getWarrantiesReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WARRANTIES_REPORT, data, onSuccess, onError);
  };

  const getLowStockReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_LOW_STOCK_REPORT, data, onSuccess, onError);
  };

  const exportClosedTasksReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_CLOSED_TASKS_REPORT_XLS, data, onSuccess, onError);
  };

  const exportAssetsUptimeReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSETS_UPTIME_REPORT_XLS, data, onSuccess, onError);
  };

  const exportAssetsTimeCostReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSETS_TIME_COST_REPORT_XLS, data, onSuccess, onError);
  };

  const exportWarrantiesReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WARRANTIES_REPORT_XLS, data, onSuccess, onError);
  };

  const exportLowStockReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_STOCK_REPORT_XLS, data, onSuccess, onError);
  };

  const exportWorkRequestOriginsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_PDF, data, onSuccess, onError);
  };

  const exportWorkRequestOriginsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_XLS, data, onSuccess, onError);
  };

  const exportGrowerTaskOriginsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_PDF, data, onSuccess, onError);
  };

  const exportGrowerTaskOriginsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_XLS, data, onSuccess, onError);
  };

  const exportUserActivitySummaryToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_PDF, data, onSuccess, onError);
  };

  const exportUserActivitySummaryToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_XLS, data, onSuccess, onError);
  };

  const exportStockAdjustmentToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_PDF, data, onSuccess, onError);
  };

  const exportStockAdjustmentToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_XLS, data, onSuccess, onError);
  };

  const exportInventoryMovementToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_PDF, data, onSuccess, onError);
  };

  const exportInventoryMovementToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_XLS, data, onSuccess, onError);
  };

  const exportManagerWorkRequestsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_PDF, data, onSuccess, onError);
  };

  const exportManagerWorkRequestsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_XLS, data, onSuccess, onError);
  };

  const exportManagerPurchasingToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_PURCHASING_PDF, data, onSuccess, onError);
  };

  const exportManagerPurchasingToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_PURCHASING_XLS, data, onSuccess, onError);
  };

  const exportTaskOriginsGallusToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_PDF, data, onSuccess, onError);
  };

  const exportTaskOriginsGallusToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_XLS, data, onSuccess, onError);
  };

  const getManagerHoursByFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_PDF, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_XLS, data, onSuccess, onError);
  };

  const exportTasksAgingPriorityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_PDF, data, onSuccess, onError);
  };

  const exportTasksAgingPriorityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_XLS, data, onSuccess, onError);
  };

  const exportWRByPriorityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_BY_PRIORITY_PDF, data, onSuccess, onError);
  };

  const exportWRByPriorityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_BY_PRIORITY_XLS, data, onSuccess, onError);
  };

  const exportTaskFunnelToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_FUNNEL_PDF, data, onSuccess, onError);
  };

  const exportTaskFunnelToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_FUNNEL_XLS, data, onSuccess, onError);
  };

  const exportHighPriorityWRsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_HIGH_PRI_WRS_PDF, data, onSuccess, onError);
  };

  const exportHighPriorityWRsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_HIGH_PRI_WRS_XLS, data, onSuccess, onError);
  };

  const exportTaskCreationTimeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_CREATION_TIME_PDF, data, onSuccess, onError);
  };

  const exportTaskCreationTimeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_CREATION_TIME_XLS, data, onSuccess, onError);
  };

  const exportTaskCompletionTimeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_PDF, data, onSuccess, onError);
  };

  const exportTaskCompletionTimeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_XLS, data, onSuccess, onError);
  };

  const exportCompletedTasksByEmployeeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_PDF, data, onSuccess, onError);
  };

  const exportCompletedTasksByEmployeeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_XLS, data, onSuccess, onError);
  };

  const exportLoggedHoursByEmployeeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_PDF, data, onSuccess, onError);
  };

  const exportLoggedHoursByEmployeeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_XLS, data, onSuccess, onError);
  };

  const exportPMReactiveToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PM_REACTIVE_PDF, data, onSuccess, onError);
  };

  const exportPMReactiveToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PM_REACTIVE_XLS, data, onSuccess, onError);
  };

  const exportPurchasingMethodToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_PDF, data, onSuccess, onError);
  };

  const exportPurchasingMethodToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_XLS, data, onSuccess, onError);
  };

  const exportPurchasingSpendToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_SPEND_PDF, data, onSuccess, onError);
  };

  const exportPurchasingSpendToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_SPEND_XLS, data, onSuccess, onError);
  };

  const exportGoodsOnOrderToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GOODS_ON_ORDER_PDF, data, onSuccess, onError);
  };

  const exportGoodsOnOrderToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GOODS_ON_ORDER_XLS, data, onSuccess, onError);
  };

  const exportLowInventoryToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_INVENTORY_PDF, data, onSuccess, onError);
  };

  const exportLowInventoryToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_INVENTORY_XLS, data, onSuccess, onError);
  };

  const exportDownAssetsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_DOWN_ASSETS_PDF, data, onSuccess, onError);
  };

  const exportDownAssetsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_DOWN_ASSETS_XLS, data, onSuccess, onError);
  };

  const exportAssetDowntimeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSET_DOWNTIME_PDF, data, onSuccess, onError);
  };

  const exportAssetDowntimeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSET_DOWNTIME_XLS, data, onSuccess, onError);
  };

  const exportMttrMtbfToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MTTR_MTBF_PDF, data, onSuccess, onError);
  };

  const exportMttrMtbfToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MTTR_MTBF_XLS, data, onSuccess, onError);
  };

  const exportReliabilityMatrixToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_PDF, data, onSuccess, onError);
  };

  const exportReliabilityMatrixToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_XLS, data, onSuccess, onError);
  };

  const exportExpiringWarrantiesToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_PDF, data, onSuccess, onError);
  };

  const exportExpiringWarrantiesToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_XLS, data, onSuccess, onError);
  };

  return {
    getAdoptionDashboardCounts,
    exportAdoptionCountsToPDF,
    exportAdoptionCountsToXLS,
    exportKpiTotalWRsToPDF,
    exportKpiTotalWRsToXLS,
    exportKpiAvgTasksToPDF,
    exportKpiAvgTasksToXLS,
    exportKpiAvgHoursToPDF,
    exportKpiAvgHoursToXLS,
    exportKpiChecklistTasksToPDF,
    exportKpiChecklistTasksToXLS,
    exportKpiChecklistCompletionToPDF,
    exportKpiChecklistCompletionToXLS,
    getWorkRequestOrigins,
    getTaskOriginsGallus,
    getGrowerTaskOrigins,
    getWRStatusPieChart,
    exportWRStatusPieChartToPDF,
    exportWRStatusPieChartToXLS,
    getUserActivitySummary,
    getStockAdjustmentChart,
    getInventoryMovementChart,
    getManagerDashboardWR,
    getManagerDashboardTeam,
    getManagerDashboardPurchasing,
    getManagerDashboardAssets,
    getClosedTasksReport,
    getAssetsUptimeReport,
    getAssetsTimeCostReport,
    getWarrantiesReport,
    getLowStockReport,
    exportWorkRequestOriginsToPDF,
    exportWorkRequestOriginsToXLS,
    exportGrowerTaskOriginsToPDF,
    exportGrowerTaskOriginsToXLS,
    exportUserActivitySummaryToPDF,
    exportUserActivitySummaryToXLS,
    exportStockAdjustmentToPDF,
    exportStockAdjustmentToXLS,
    exportInventoryMovementToPDF,
    exportInventoryMovementToXLS,
    exportManagerWorkRequestsToPDF,
    exportManagerWorkRequestsToXLS,
    exportManagerPurchasingToPDF,
    exportManagerPurchasingToXLS,
    exportTaskOriginsGallusToPDF,
    exportTaskOriginsGallusToXLS,
    getManagerHoursByFacility,
    exportManagerHoursByFacilityToPDF,
    exportManagerHoursByFacilityToXLS,
    exportTasksAgingPriorityToPDF,
    exportTasksAgingPriorityToXLS,
    exportWRByPriorityToPDF,
    exportWRByPriorityToXLS,
    exportTaskFunnelToPDF,
    exportTaskFunnelToXLS,
    exportHighPriorityWRsToPDF,
    exportHighPriorityWRsToXLS,
    exportTaskCreationTimeToPDF,
    exportTaskCreationTimeToXLS,
    exportTaskCompletionTimeToPDF,
    exportTaskCompletionTimeToXLS,
    exportCompletedTasksByEmployeeToPDF,
    exportCompletedTasksByEmployeeToXLS,
    exportLoggedHoursByEmployeeToPDF,
    exportLoggedHoursByEmployeeToXLS,
    exportPMReactiveToPDF,
    exportPMReactiveToXLS,
    exportPurchasingMethodToPDF,
    exportPurchasingMethodToXLS,
    exportPurchasingSpendToPDF,
    exportPurchasingSpendToXLS,
    exportGoodsOnOrderToPDF,
    exportGoodsOnOrderToXLS,
    exportLowInventoryToPDF,
    exportLowInventoryToXLS,
    exportDownAssetsToPDF,
    exportDownAssetsToXLS,
    exportAssetDowntimeToPDF,
    exportAssetDowntimeToXLS,
    exportMttrMtbfToPDF,
    exportMttrMtbfToXLS,
    exportReliabilityMatrixToPDF,
    exportReliabilityMatrixToXLS,
    exportExpiringWarrantiesToPDF,
    exportExpiringWarrantiesToXLS,
    exportClosedTasksReportToXLS,
    exportAssetsUptimeReportToXLS,
    exportAssetsTimeCostReportToXLS,
    exportWarrantiesReportToXLS,
    exportLowStockReportToXLS,
  };
}
